import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { NbCardModule } from "@nebular/theme";

@Component({
    selector: "ngx-not-found",
    templateUrl: "./not-found.component.html",
    styleUrls: ["./not-found.component.scss"],
    imports: [NbCardModule],
    standalone: true
})
/** 404 screen rendered for unmatched routes (`**` wildcard). */
export class NotFoundComponent {
  constructor(private router: Router) {}

  /** Navigates back to the app root. */
  goHome() {
    this.router.navigate(["/"]);
  }
}
